import { uniq } from 'vtils'

// 历史数据
export const historyModel = {
  key: '__dd_mall_history_data__',

  get() {
    return JSON.parse(localStorage.getItem(historyModel.key) || '[]')
  },

  set(keywords: string[]) {
    return localStorage.setItem(
      historyModel.key,
      JSON.stringify(uniq(keywords.filter(Boolean))),
    )
  },

  add(keyword: string) {
    return historyModel.set([keyword, ...historyModel.get()])
  },

  clear() {
    return historyModel.set([])
  },
}
